import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import AddressInput from '../AddressField/AddressInput/AddressInput';
import AddressDropDown from '../AddressField/AddressDropDown/AddressDropDown';
import { getValueByDotKey } from '../../../tools/validations/address';
import $window from '../../../tools/window';

const textProp = PropTypes.shape({
  key: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

const optionProp = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

export const addressFieldProp = PropTypes.shape({
  label: textProp,
  labelFor: PropTypes.string,
  error: textProp,
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  visibility: PropTypes.bool,
  maxLength: PropTypes.number,
  validationRule: PropTypes.string,
  required: PropTypes.bool,
  defaultValue: PropTypes.string,
  component: PropTypes.string,
  options: PropTypes.arrayOf(optionProp),
});

const propTypes = {
  field: addressFieldProp.isRequired,
  validateFn: PropTypes.func,
  errorTmnts: PropTypes.shape({}),
};

export default function AddressFieldItem(props) {
  const {
    field: addressField, validateFn, errorTmnts,
  } = props;

  const {
    control, formState: { errors },
  } = useFormContext();

  if (!addressField.visibility) {
    return <input id={addressField.id} name={addressField.name} type="hidden" value={addressField.defaultValue} />;
  }

  const isInvalid = getValueByDotKey(errors, addressField.name);

  switch (addressField.component) {
    case 'ADDRESS_INPUT':
      return (
        <Controller
          name={addressField.name}
          control={control}
          rules={{
            validate: validateFn,
            required: {
              value: true,
              message: 'enterValidField',
            },
          }}
          defaultValue={addressField.defaultValue}
          render={({ field }) => (
            <AddressInput
              maxLength={addressField.maxLength}
              label={addressField.label}
              name={addressField.name}
              type={addressField.type}
              isRequired={addressField.required}
              id={addressField.id}
              error={isInvalid ? (errorTmnts?.[isInvalid.message] || addressField.error) : null}
              isInvalid={!!isInvalid}
              {...field}
            />
          )}
        />
      );
    case 'ADDRESS_DROPDOWN':
      return (
        <Controller
          name={addressField.name}
          control={control}
          rules={{
            validate: validateFn,
            required: {
              value: true,
              message: 'enterValidField',
            },
          }}
          defaultValue={addressField.defaultValue}
          render={({ field }) => (
            <AddressDropDown
              label={addressField.label}
              name={addressField.name}
              isRequired={addressField.required}
              options={addressField.options}
              id={addressField.id}
              error={isInvalid ? (errorTmnts?.[isInvalid.message] || addressField.error) : null}
              isInvalid={!!isInvalid}
              {...field}
              onChange={(e) => {
                if (addressField.id === 'billing-country') {
                  $window.dispatchEvent(new CustomEvent('billing:country-selected', { detail: { country: e.target.value } }));
                }
                field.onChange(e);
              }}
            />
          )}
        />
      );
    default:
      return null;
  }
}

AddressFieldItem.propTypes = propTypes;
AddressFieldItem.defaultProps = {
  validateFn: undefined,
  errorTmnts: undefined,
};
